import * as FilePond from 'filepond'
import 'jquery-filepond/filepond.jquery'
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';

$(document).on('turbo:load', () => {
    $.fn.filepond.registerPlugin(FilePondPluginFileValidateType);
    $('#sample-id-filepond').filepond(
        {
            name: 'kit_registration[sample_names]',
            storeAsFile: true,
            labelIdle: 'Drag & drop your sample name file or <span class="filepond--label-action"> click to browse </span>'
        }
    );

    $('#analyte-entries-filepond').filepond(
        {
            name: 'analyte_entries',
            storeAsFile: true,
            labelIdle: 'Drag & drop your analyte entries .csv or <span class="filepond--label-action"> click to browse </span>'
        }
    );
    $('#cal-qc-concentrations-filepond').filepond(
        {
            name: 'cal_qc_concentrations',
            storeAsFile: true,
            labelIdle: 'Drag & drop your unscheduled data file or <span class="filepond--label-action"> click to browse </span>'
        }
    );
    // $('#experiment-zip-filepond').filepond(
    //     {
    //         name: 'experimeny_zip',
    //         storeAsFile: true,
    //         labelIdle: 'Drag & drop your zipped experiment data or <span class="filepond--label-action"> Browse </span>',
    //         fileValidateTypeLabelExpectedTypes: 'Please upload a ZIP file containing your experiment data'
    //     });
    //'FilePond:addfile' updatefiles
    $('#unscheduled_data-id-filepond').filepond(
        {
            name: 'kit_registration[unscheduled_data]',
            storeAsFile: true,
            labelIdle: 'Drag & drop your unscheduled data <span style="color:blue; font-weight:bold;">.zip</span> file or <span class="filepond--label-action"> click to browse </span>'
        }
    );
    document.addEventListener('FilePond:addfile', e => {
        // //alert("check addEventListener");
        // const submitButton = document.getElementById('submit-unscheduled-data');
        // const dt = new DataTransfer();
        // dt.items.add(e.detail.file.file);
        // let fi = e.target.querySelector('input');
        // fi.files = dt.files;
        // if(fi.files.length > 0) submitButton.disabled = false;
        // else submitButton.disabled = true;
        // submitButton.disabled = false;

        const dt = new DataTransfer();
        dt.items.add(e.detail.file.file);

        let fi = e.target.querySelector('input');
        fi.files = dt.files;
    })
    document.addEventListener('FilePond:removefile', e => {
        const submitButton = document.getElementById('submit-unscheduled-data');
        submitButton.disabled = true;
    })
})